export default __webpack_public_path__ + "static/impulsamos-b5c6b2c97ef7482b3db736189ba24d11.png";